<div class="row medium-14-16">
  <div class="col-4">Vessel name</div>
  <div class="col-4">ENI number</div>
  <div class="col-4">IMO number</div>
</div>
<div class="row regular-14-16">
  <div class="col-4">{{selection.bunkerVessel.name}}</div>
  <div class="col-4">{{selection.bunkerVessel.eni}}</div>
  <div class="col-4">{{selection.bunkerVessel.imo}}</div>
</div>
